// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { Link, IButtonStyles, ITextStyles, ITheme, IconButton, Stack, Text, useTheme } from '@fluentui/react';

export const SoundEffectsModalHeader = (props: { onCloseClick: () => void }): JSX.Element => {
  const theme = useTheme();
  return (
    <Stack tokens={{ childrenGap: '0.5rem' }}>
      <Stack horizontal horizontalAlign="space-between" verticalAlign="center">
        <Stack horizontal>
          <Text variant="large">Play sound effect</Text>
        </Stack>
        <Stack.Item>
          <IconButton
            styles={iconButtonStyles(theme)}
            iconProps={{ iconName: 'Cancel' }}
            ariaLabel="Close popup modal"
            onClick={props.onCloseClick}
          />
        </Stack.Item>
      </Stack>
      <Text variant="small" styles={subHeaderStyles(theme)}>
        Play an interactive sound effect for everyone in the meeting.
        <br />
        <SoundEffectsAttribution />
      </Text>
    </Stack>
  );
};

const SoundEffectsAttribution = (): JSX.Element => {
  return (
    <Text variant="small" styles={subHeaderStyles(useTheme())}>
      Sound effects from{' '}
      <Link href="https://quicksounds.com" target="_blank">
        quicksounds.com
      </Link>{' '}
      and{' '}
      <Link href="https://www.bensound.com" target="_blank">
        bensound.com
      </Link>
      .
    </Text>
  );
};

const iconButtonStyles = (theme: ITheme): Partial<IButtonStyles> => ({
  root: {
    color: theme.palette.neutralPrimary
  },
  rootHovered: {
    color: theme.palette.neutralDark
  }
});

const subHeaderStyles = (theme: ITheme): Partial<ITextStyles> => ({
  root: {
    color: theme.palette.neutralSecondary
  }
});
